import { FrameWorkGetMapFromItem, FrameWorkGetPrimaryColorButton, FrameWorkGetSecundaryColorButton, FrameWorkHideAlert, FrameWorkMessageErrorAlert, FrameWorkModalQuantity, FrameWorkSimpleMessageState, OrdenExpressApplyFiltersSpecificProducts, OrdenExpressGetProductFromVector, OrdenExpressIsAdmin, OrdenExpressNavegatePath, OrdenExpressSetProductToVector, OrdenExpressValidateSecurity } from 'orden_express/frameWork/frameWork';
import { setListOfProductsForBeginingOrder } from 'orden_express/orders/ordersActions';
import { requestSaveOrderProductDetail } from 'orden_express/orders/ordersEpic';
import { setDataProductForEdit, setFilterTextSearchProduct, setMessageProductState } from 'orden_express/products/productsActions';
import { requestGetAllProducts, requestGetProductsFilter } from 'orden_express/products/productsEpic';
import ProductsFilter from 'orden_express/products/ProdutsFilter';
import React from 'react';
import { connect } from 'react-redux';
import { Badge, Button, Card, CardBody, Col, Row, UncontrolledTooltip, Pagination, PaginationItem, PaginationLink, } from 'reactstrap';
import { bindActionCreators } from 'redux';



class ProductsMain extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      addToCart: '',
      localValueQuantityProductToCart: 0,
      isFromOrders: false,
      isFromMakeOrder: false,
    }
    OrdenExpressValidateSecurity(this);
  }

  onBackButtonEvent = (e) => {
    //e.preventDefault();
    //alert('hacia atras');
  }


  componentDidMount() {
    try {
      window.onpopstate = this.onBackButtonEvent;
      const queryParams = new URLSearchParams(this.props.location.search);
      this.setState({ isFromOrders: queryParams.get('isFromOrders') || false });
      this.setState({ isFromMakeOrder: queryParams.get('isFromMakeOrder') || false });
    } catch (__) { }
    this.applyFilters();
  }

  componentDidUpdate(prevProps) {

    if (prevProps.location.key !== this.props.location.key) {
      // this.setState(this.getIncialState());
      this.props.setFilterTextSearchProduct('');
      this.applyFilters();
    }
    if (this.props.productsReducerState.filterTextSearchProduct !== prevProps.productsReducerState.filterTextSearchProduct) {
      this.applyFilters();
    }
    if (this.props.productsReducerState.messageProductState !== prevProps.productsReducerState.messageProductState) {
      this.processMessageState(this.props.productsReducerState.messageProductState);
    }

  }

  sendToEditProduct = (pProduct) => {
    if (OrdenExpressIsAdmin(this)) {
      this.props.setDataProductForEdit(pProduct);
      OrdenExpressNavegatePath(this, 'productsForm');
    }
  }

  applyFilters = (pAction = 0, pPage = 1) => {
    this.props.setMessageProductState(1);
    OrdenExpressApplyFiltersSpecificProducts(
      this.props.productsReducerState,
      this.props,
      pAction,
      this.props.productsReducerState.availableOffsetSearchProduct,
      pPage);
  }

  newAddtoCart = (pProduct, pValue) => {
    this.closeAddtoCart();
    var localProduct = pProduct;
    localProduct['quantityRequested'] = parseInt(pValue, 10);
    localProduct['quantityShipped'] = localProduct['quantityRequested'];
    if (this.state.isFromOrders) {
      var localOrder = this.props.ordersReducerState.responseGetOrderRequestedDetail.result;
      try {
        localProduct = OrdenExpressGetProductFromVector(localOrder, 'orderDetails', pProduct.id, 'product');
        if (localProduct != null) {
          localProduct.quantityShipped = pValue;
        } else {
          localProduct = {
            id: 0,
            order: localOrder.id,
            product: pProduct.id,
            quantityRequested: parseInt(pValue, 10),
            quantityShipped: parseInt(pValue, 10),
            packed: 0,
            dispatched: 0,
            received: 0,
            active: 1
          }
        }
        this.props.requestSaveOrderProductDetail(localProduct);
      } catch (__) { }
    } else {
      var newListOfProducts = OrdenExpressSetProductToVector(this.props.ordersReducerState, 'listOfProductsForBeginingOrder', localProduct);
      this.props.setListOfProductsForBeginingOrder(newListOfProducts);
    }
  }

  closeAddtoCart = () => {
    this.setState({ addToCart: '' });
  }

  addToCart = (pProduct) => {
    var actualValue = 1;
    var localProductFromVector;
    if (this.state.isFromOrders) {
      try {
        localProductFromVector = OrdenExpressGetProductFromVector(this.props.ordersReducerState.responseGetOrderRequestedDetail.result, 'orderDetails', pProduct.id, 'product');
        if (localProductFromVector != null) {
          actualValue = localProductFromVector.quantityShipped;
        }
      } catch (__) { }
    } else {
      localProductFromVector = OrdenExpressGetProductFromVector(this.props.ordersReducerState, 'listOfProductsForBeginingOrder', pProduct.id);
      if (localProductFromVector != null) {
        actualValue = localProductFromVector.quantityRequested;
      }
    }

    FrameWorkModalQuantity(this, 'addToCart', 'localValueQuantityProductToCart', pProduct, this.newAddtoCart, this.closeAddtoCart, actualValue);
  }

  filterForClientViewOnlyActiveProducts = (pData) => {
    if (OrdenExpressIsAdmin(this)) {
      return pData;
    }
    var result = [];
    try {
      var pos = 0;
      var length = pData.length;
      while (pos < length) {
        var pProduct = pData[pos];
        if (pProduct.active !== 0) {
          result.push(pProduct);
        }
        pos++;
      }
      /*pData.map((pProduct) => {
        if (pProduct.active !== 0) {
          result.push(pProduct);
        }
      });*/
    } catch (__) { }
    return result;
  }

  /**
   * Controla la secuencia de estados para visualizar 
   * los mensajes en el proceso 
   */
  processMessageState = (pStateForMessage) => {
    switch (pStateForMessage) {
      case 1://procesando solicitud
        FrameWorkSimpleMessageState(this, 'Mostrando productos', 'Su solicitud está en proceso ...');
        break;
      case 2:
        FrameWorkHideAlert(this);
        this.props.setMessageProductState(0);
        //FrameWorkMessageSuccessAlert(this, 'Correcto!', 'Los datos fueron correctamente almacenados', this.props.history.goBack,this.props.history.goBack);
        break;
      case 3:
        var localMessageError = this.props.productsReducerState.responseGetAllProducts;
        FrameWorkMessageErrorAlert(this, 'Error :(', localMessageError.message);
        console.error(localMessageError)
        break;
      default:
        FrameWorkHideAlert(this);
        this.props.setMessageProductState(0);
        break;
    }
  }

  renderButtonToReturn = () => {
    /*if(!(this.state.isFromOrders || this.state.isFromMakeOrder)){
      return('');
    }*/
    return (
      <Button
        color={FrameWorkGetSecundaryColorButton()}
        className='btn-round mt-2 mb-0 ml-6'
        style={{ width: 145 }}
        onClick={() => {
          if (!(this.state.isFromOrders || this.state.isFromMakeOrder)) {
            //this.props.history.push('/admin/makeOrder');
            OrdenExpressNavegatePath(this, 'makeOrder');
          } else {
            try {
              this.props.history.goBack();
            } catch (__) {
              if (this.state.isFromOrders) {
                //this.props.history.push('/admin/processOrders');
                OrdenExpressNavegatePath(this, 'processOrders');
              } else {
                //this.props.history.push('/admin/makeOrder');
                OrdenExpressNavegatePath(this, 'makeOrder');
              }
            }
          }
        }
        }>
        <i className='icon-big nc-icon nc-minimal-left text-white' />
        {'Regresar'}
      </Button>
    )
  }

  renderButtonNewProduct = () => {
    if (OrdenExpressIsAdmin(this)) {
      return (
        <Button
          color={FrameWorkGetSecundaryColorButton()}
          className='btn-round mb-0 ml-6'
          style={{ width: 145 }}
          onClick={() => { this.sendToEditProduct(null) }}>
          <i className='icon-big nc-icon nc-box text-white' />
          {'+ Crear'}
        </Button>
      );
    }
    return (<></>);
  }

  renderNavigationElement = (pNavigation) => {
    if (!pNavigation) {
      return (<></>);
    }
    if (!pNavigation.totalPages) {
      return (<></>);
    }
    var pos = 0;
    var length = pNavigation.totalPages;
    var actualPage = pNavigation.actualPage;
    var widthScree = window.innerWidth;
    var maximun = widthScree / 55 >> 0;
    var content = [];
    pos = (actualPage / maximun >> 0) * maximun;
    if (actualPage % maximun === 0) {
      pos = ((actualPage / maximun >> 0) - 1) * maximun
    }
    var index = 0;
    var firstNumber = pos;
    while ((pos < length) && (index < maximun)) {
      pos++;
      index++;
      content.push(pos);
    }
    if (pos === length) {
      while (maximun > content.length && firstNumber > 0) {
        var complement = [];
        complement.push(firstNumber);
        content = complement.concat(content);
        firstNumber--;
      }

    }

    return content.map((element, index) => {
      return (
        <PaginationItem
          key={`keyItem${element}`}
          className={element === actualPage ? "bg-warning rounded-circle" : ""}
        >
          <PaginationLink
            href=""
            onClick={e => this.applyFilters(6, element)}
          >
            {element}
          </PaginationLink>
        </PaginationItem>
      )
    });
  }

  renderNextNavegation = (pNavigation) => {
    try {
      if (pNavigation.actualPage === pNavigation.totalPages) {
        return (<></>)
      }
      return (
        <PaginationItem>
          <PaginationLink
            aria-label="Siguiente"
            href=""
            onClick={e => this.applyFilters(1)}
          >
            <span aria-hidden={true}>
              <i
                aria-hidden={true}
                className="fa fa-angle-double-right"
              />
            </span>
          </PaginationLink>
        </PaginationItem>
      );
    } catch (__) { }
  }

  renderPreviusNavegation = (pNavigation) => {
    try {
      if (pNavigation.actualPage === 1) {
        return (<></>)
      }
      return (
        <PaginationItem>
          <PaginationLink
            aria-label="Anterior"
            href=""
            onClick={e => this.applyFilters(2)}
          >
            <span aria-hidden={true}>
              <i
                aria-hidden={true}
                className="fa fa-angle-double-left"
              />
            </span>
          </PaginationLink>
        </PaginationItem>
      );
    } catch (__) { }
  }
  renderNavigation = (pNavigation) => {

    return (
      <CardBody>
        <nav aria-label="Page navigation example">
          <Pagination>
            {this.renderPreviusNavegation(pNavigation)}
            {this.renderNavigationElement(pNavigation)}
            {this.renderNextNavegation(pNavigation)}
          </Pagination>
        </nav>
      </CardBody>
    );
  }
  render() {
    var localProducts = [];
    try {
      localProducts = FrameWorkGetMapFromItem(this.props.productsReducerState.responseGetAllProducts, 'result');
    } catch (_) { }
    localProducts = this.filterForClientViewOnlyActiveProducts(localProducts);//cuando es admin ve los inactivos cuando es cliente no
    return (
      <div className='content mt-5 mb-0'>
        {this.state.alert}
        {this.state.addToCart}
        <div className='framework-flexcontainer'>
          <div>
            <h4>{'Productos'}</h4>
          </div>
          <div className='text-right framework-flex-rigth mt-2'>
            {this.renderButtonToReturn()}
            {this.renderButtonNewProduct()}
          </div>
        </div>
        <div>
          <ProductsFilter parent={this} />
        </div>
        {
          localProducts.map((itemProduct, indexproduct) => {
            return (
              <Card className={`mt-0 mb-1 ${indexproduct % 2 === 0 ? 'bg-gray' : 'bg-white'}`} key={`idRowTableProducts'${indexproduct}`}>
                <CardBody>
                  <Row>
                    <Col xs='auto'>
                      <Button
                        className='btn-icon btn-round'
                        color={FrameWorkGetPrimaryColorButton()}
                        id={`editProduct${indexproduct}`}
                        type='button'
                        outline
                        size='lg'

                        disabled={itemProduct.active !== 1 ? true : false}
                        onClick={value => {
                          this.addToCart(itemProduct);
                        }}
                      >
                        <i className='fa fa-cart-plus' />
                      </Button>
                      <UncontrolledTooltip
                        delay={0}
                        target={`editProduct${indexproduct}`}
                      >
                        {'Agregar producto'}
                      </UncontrolledTooltip>
                    </Col>
                    <Col>

                      <div
                        className='framework-flexcontainer'
                        onClick={value => {
                          this.sendToEditProduct(itemProduct);
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        <b>
                          {itemProduct.name}
                          {' ('}
                          {itemProduct.nameMeasureUnit}
                          {')'}
                        </b>
                        <Badge className='framework-flex-rigth' style={{ width: 80 }} color={itemProduct.active === 1 || itemProduct.active === true ? 'success' : 'danger'} pill>
                          {itemProduct.active === 1 || itemProduct.active === true ? 'Activo' : 'Inactivo'}
                        </Badge>
                      </div>
                      <div className='framework-flexcontainer'>
                        <div onClick={value => {
                          this.sendToEditProduct(itemProduct);
                        }}
                          style={{ cursor: 'pointer' }}
                        >
                          {'Código:'}
                          {itemProduct.code}
                          {' '}
                          {'Cantidad mínima: '}
                          {itemProduct.quantityAvailable}
                          {' ('}
                          {itemProduct.nameMeasureUnit}
                          {') '}
                          {'Categoría: ' + itemProduct.nameCategory}
                        </div>
                        <div className='framework-flex-rigth mr-1'>
                          <span id={`moreInformation${indexproduct}`}>
                            <i className='fa fa-ellipsis-v mr-0 text-right' style={{ height: 20, width: 30 }} />
                          </span>
                          <UncontrolledTooltip
                            delay={0}
                            target={`moreInformation${indexproduct}`}
                          >
                            {itemProduct.information}
                          </UncontrolledTooltip>
                        </div>
                      </div>

                    </Col>
                  </Row>
                </CardBody>
              </Card>
            )
          })
        }
        <div className='framework-flexcontainer'>
          <div>
            {''}
          </div>
          <div className='text-right framework-flex-rigth'>
            {this.renderNavigation(this.props.productsReducerState.responseGetAllProducts.filterNavegation)}
          </div>
        </div>
        {/*
        <Card className={`mt-0 mb-1 bg-transparent`}>
          <CardFooter className='framework-flexcontainer'>
            <ButtonGroup className='btn-group btn-group-sm framework-flex-rigth'>
              <Button
                className='btn-round'
                color='warning'
                outline
                type='button'
                onClick={e => this.applyFilters(2)}
              >
                {'<<'}
              </Button>

              <div
                className='text-center border border-0 bg-warning pt-2'
                style={{ width: 80, color: '#ffffff' }}
              >
                <h6>
                  {`${actualPage} de ${totalPages}`}
                </h6>
              </div>

              <Button
                className='btn-round'
                color='warning'
                outline
                type='button'
                onClick={e => this.applyFilters(1)}
              >
                {'>>'}
              </Button>
            </ButtonGroup>
          </CardFooter>
          
        </Card>
        */}
        <div className='framework-flexcontainer'>
          <div>
            {''}
          </div>
          <div className='text-right framework-flex-rigth'>
            {this.renderButtonToReturn()}
            {this.renderButtonNewProduct()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    productsReducerState: state.productsReducerState,
    ordersReducerState: state.ordersReducerState,
    loginReducerState: state.loginReducerState
  };
};

const mapDispatchToProps = dispatch => {
  return {

    setMessageProductState: (messageProductState) => dispatch(setMessageProductState(messageProductState)),
    setFilterTextSearchProduct: filterTextSearchProduct => dispatch(setFilterTextSearchProduct(filterTextSearchProduct)),

    requestGetAllProducts: () => bindActionCreators(dispatch(requestGetAllProducts())),
    setDataProductForEdit: dataProductForEdit => dispatch(setDataProductForEdit(dataProductForEdit)),
    requestGetProductsFilter: (getFilterProducts) => bindActionCreators(dispatch(requestGetProductsFilter(getFilterProducts))),
    setListOfProductsForBeginingOrder: (listOfProductsForBeginingOrder) => dispatch(setListOfProductsForBeginingOrder(listOfProductsForBeginingOrder)),
    requestSaveOrderProductDetail: (dataRequestSaveOrderProductDetail) => bindActionCreators(dispatch(requestSaveOrderProductDetail(dataRequestSaveOrderProductDetail)), dispatch),

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductsMain);